<template>
  <v-container fluid>
    <notifications group="actions"></notifications>
    <h2>
      <span class="display-1 font-weight-light">Dashboard</span>
    </h2>
    <v-flex>
      <v-row>
        <v-col cols="6" class="col-lg-8">
          <v-card style="min-height: 100%">
            <v-card-title>
              <h2>Engagement average</h2>
            </v-card-title>
            <v-card-text>
              <trend-line-company :company-avg="teamAverage" v-if="teamAverage && teamAverage.length > 2"></trend-line-company>
              <div class="mt-12 text-center" v-else>
                <p class="display-1">No data enough</p>
                <p class="mt-2">To draw a trend we need a minimum of 3 iterations. Currently happened {{iterations}} iterations</p>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6" class="col-lg-4">
          <user-state-of-the-art :user="user" :team-average="teamAverage"></user-state-of-the-art>
        </v-col>
        <v-col cols="12" class="col-md-6">
          <v-card style="min-height: 100%">
            <v-card-title>
              <h2>Staff engagement distribution</h2>
            </v-card-title>
            <v-card-text>
              <engagement-bars :engagement="staffSummary" :colors="colorsStaffEngagement" v-if="hasStaff"></engagement-bars>
              <v-flex v-else class="d-flex mt-10 justify-center">
                <btn-add-staff />
              </v-flex>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" class="col-md-6">
          <v-card style="min-height: 100%">
            <v-card-title>
              <h2>Scouting contact chance distribution</h2>
            </v-card-title>
            <v-card-text>
              <engagement-bars :engagement="scoutingSummary" :colors="colorsScoutingEngagement" v-if="hasScouting"></engagement-bars>
              <v-flex v-else class="d-flex mt-10 justify-center">
                <btn-add-scouting />
              </v-flex>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" class="col-md-6">
          <v-card style="min-height: 100%">
            <v-card-title>
              <h2>Top5 staff at Low or Medium</h2>
            </v-card-title>
            <v-card-text>
              <v-row v-if="hasStaff">
                <v-col v-for="(profile, key) of staffMembers" :key="key">
                  <profile-card :profile="profile" :group="'staff'"></profile-card>
                </v-col>
              </v-row>
              <v-flex v-else class="d-flex mt-10 justify-center">
                <btn-add-staff />
              </v-flex>

            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" class="col-md-6">
          <v-card style="min-height: 100%">
            <v-card-title>
              <h2>Top5 scouting at Hot or Average</h2>
            </v-card-title>
            <v-card-text>
              <v-row v-if="hasScouting">
                <v-col v-for="(profile, key) of scoutingMembers" :key="key" >
                  <profile-card :profile="profile" :group="'scouting'"></profile-card>
                </v-col>
              </v-row>
              <v-flex v-else class="d-flex mt-10 justify-center">
                <btn-add-scouting />
              </v-flex>

            </v-card-text>
          </v-card>
        </v-col>

      </v-row>
    </v-flex>
  </v-container>
</template>

<script>

  import api from '@/api/index';
  import TrendLineCompany from "../../components/Charts/dashboard/TrendLineCompany";
  import UserStateOfTheArt from "../../components/Widgets/UserStateOfTheArt";
  import EngagementBars from "../../components/Charts/Dashboard/EngagementBars";
  import ProfileCard from "../../components/Widgets/ProfileCard";
  import BtnAddStaff from "../../components/Buttons/Profiles/BtnAddStaff";
  import BtnAddScouting from "../../components/Buttons/Profiles/BtnAddScouting";


  export default {

    name: 'IcevergDashboard',
    components: {BtnAddScouting, BtnAddStaff, ProfileCard, EngagementBars, UserStateOfTheArt, TrendLineCompany},
    data() {
      return {
        teamAverage: undefined,
        user: {},
        colorsStaffEngagement: {
          good: 'green',
          medium: 'darkorange',
          low: 'red',
        },
        colorsScoutingEngagement: {
          cold: 'blue',
          average: 'purple',
          hot: 'red',
        }
      }
    },
    mounted() {
      this.loadCompanyEngagementAverage()
      this.loadUser()
    },
    methods: {
      loadCompanyEngagementAverage() {
        api.clients.getEngagementAverage({})
          .then(response => {
            this.teamAverage = response.data.data.teamAverage
          })
      },
      loadUser(){
        let clientId = this.userData.clientId;
        api.clients.getSelfUser({clientId})
        .then(response => {
          this.user = response.data.data.user
        })
      }
    },
    computed: {
      userData() {
        return this.$store.getters.getUserFromToken;
      },
      hasStaff() {
        return this.user && this.user.edges && this.user.edges.staff && this.user.edges.staff.count > 0
      },
      hasScouting() {
        return this.user && this.user.edges && this.user.edges.scouting && this.user.edges.scouting.count > 0
      },
      staffMembers(){
        let members = []
        if (this.user && this.user.edges && this.user.edges.staff) {
          members = this.user.edges.staff.members
        }
        return members
      },
      scoutingMembers(){
        let members = []
        if (this.user && this.user.edges && this.user.edges.scouting) {
          members = this.user.edges.scouting.members
        }
        return members
      },
      staffSummary() {
        let summary = {}
        if (this.user && this.user.edges && this.user.edges.staff && this.user.edges.staff.summary) {
          summary.good = this.user.edges.staff.summary.good
          summary.medium = this.user.edges.staff.summary.medium
          summary.low = this.user.edges.staff.summary.low
        }
        return summary
      },
      scoutingSummary() {
        let summary = {}
        if (this.user && this.user.edges && this.user.edges.staff && this.user.edges.scouting.summary) {
          summary.cold = this.user.edges.scouting.summary.cold
          summary.average = this.user.edges.scouting.summary.average
          summary.hot = this.user.edges.scouting.summary.hot
        }
        return summary
      },
      iterations() {
        return this.teamAverage ? this.teamAverage.length : 0
      }
    }
  }
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/dashboard/IcevergDashboard.vue